import React from 'react';
import PropTypes, { object } from 'prop-types';

import { Heading } from 'components/common/Elements/Elements';
import { DonutNew } from 'components/common/charts/charts';
import { LegendStatus } from 'components/common/charts/parts/parts';

import classes from './TicketsStatus.module.scss';

const TicketsStatus = ({ data, chartColor }) => (
  <section className={classes.box}>
    <Heading>Support Tickets Status</Heading>
    <div className={classes.content}>
      <DonutNew data={data} chartColor={chartColor} className={classes.donut} />
      <LegendStatus legendData={data} chartColor={chartColor} />
    </div>
  </section>
);

TicketsStatus.propTypes = {
  data: PropTypes.arrayOf(object),
  chartColor: PropTypes.object
};

export default TicketsStatus;
